import axios from 'axios';
import getBootstrapData from 'src/utils/getBootstrapData';

export type IPagination = {
  page: number;
  limit: number;
  sortField: string;
  sortDirection: string;
};

const bootstrapData = getBootstrapData();
const headers = {
  'X-API-KEY': bootstrapData?.common?.conf?.UT_API_KEY,
};

export default class BaseRequest {
  getUrlPrefix() {
    const host =
      bootstrapData?.common?.conf?.UT_API_HOST || 'http://localhost:3000';
    return host + '/v1';
  }

  async get(url: string, params?: any) {
    try {
      const config = {
        params,
        headers,
      };
      return await axios.get(this.getUrlPrefix() + url, config);
    } catch (error) {
      return this._errorHandler(error);
    }
  }

  async put(url: any, data: any) {
    try {
      const response = await axios.put(this.getUrlPrefix() + url, data, {
        headers,
      });
      return this._responseHandler(response);
    } catch (error) {
      return this._errorHandler(error);
    }
  }

  async patch(url: any, data: any) {
    try {
      const response = await axios.patch(this.getUrlPrefix() + url, data, {
        headers,
      });
      return this._responseHandler(response);
    } catch (error) {
      return this._errorHandler(error);
    }
  }

  async post(url: any, data: any) {
    try {
      const response = await axios.post(this.getUrlPrefix() + url, data, {
        headers,
      });
      return this._responseHandler(response);
    } catch (error) {
      return this._errorHandler(error);
    }
  }

  async delete(url: any, data?: any) {
    try {
      const config = {
        data,
        headers,
      };
      const response = await axios.delete(this.getUrlPrefix() + url, config);
      return this._responseHandler(response);
    } catch (error) {
      return this._errorHandler(error);
    }
  }

  async _responseHandler(response: any) {
    return response.data;
  }

  _errorNavigator(err: any) {
    if (!err.response || !err.response.status) {
      return;
    }
    switch (err.response.status) {
      case 403:
        window.location.pathname = '/403';
        break;
      default:
        break;
    }
  }

  async _errorHandler(err: any) {
    this._errorNavigator(err);
    if (err?.response?.data?.message[0]) {
      throw new Error(err.response.data.message[0]);
    }
    if (err.response && err.response.data && err.response.data.error) {
      throw new Error(err.response.data.error);
    }
    throw err;
  }
}
